import React from "react";
import './CarsType.css';

import { Heading, PageTitle, Category } from "../../../components";
import { cars } from "../../../constants";
import { getPopularCarCategories } from "../../../utils";



const CarsType = () => {

  // Get the Car Categories
  const categories = getPopularCarCategories(cars);

  return (

    <>

      {/* Page title */}
      <PageTitle title={'Cars Type'} page={'Cars Type'} />

      <section className="car-type">

        {/* Section Heading */}
        <Heading title={'Explore Our Rental Cars'} subTitle={'Car Categories'} />

        {/* Category Items */}
        <div className="box-container">

          {/* Map over the categories array to render each category */}
          {categories.map(({ index, category, count, image }) => (
            <Category
              key={index}
              index={index}
              category={category}
              count={count}
              image={image}
            />
          ))}

        </div>

      </section>

    </>
  );
};

export default CarsType;